@if (starCount == null || starCount == 0) {
  <p class="rating-error">
    Star count is <strong>required</strong> and cannot be zero
  </p>
} @else {
  <div class="rating-container">
    @for (item of ratingArr; track $index) {
      <abc-button
        [disabled]="disabled"
        [id]="'star_' + $index"
        (click)="onClick($index + 1)"
        [icon]="icon"
        class="rating-button"
        [elementAttr]="{
          style:
            '--rating-button-color: ' +
            getColor($index) +
            '; --primary-rating-color: ' +
            fillColor,
        }"
      >
      </abc-button>
    }
  </div>
}
